import script from "./BankingSummaryCard.vue?vue&type=script&setup=true&lang=js"
export * from "./BankingSummaryCard.vue?vue&type=script&setup=true&lang=js"

import "./BankingSummaryCard.vue?vue&type=style&index=0&id=653ab45a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-653ab45a"]])

export default __exports__